// @flow
import React, { memo } from "react";
import t from "common/i18n";
import DropdownList from "root/components/DropdownList/DropdownList";
import consts from "../../data/consts";

type Props = {
    className: string,
    value: string,
    setSort: Function,
};

export const SORT_ITEMS: Object[] = consts.SORT_OPTIONS.map((value: string) => ({ label: t(`shutterstock.filters.sort_options.${value}`), value }));

export const getSelectedItem = (value: string): Object => SORT_ITEMS.find((item) => item.value === value) || {};

const SortBy = (props: Props) => {
	const selectedItem = getSelectedItem(props.value);

	return (<section className={props.className} >
		<label>{t("shutterstock.filters.sort_options.label")}</label>
		<DropdownList
			className="z-2"
			items={SORT_ITEMS}
			selectedItem={selectedItem}
			onChange={props.setSort} />
	</section>);
};

export default memo<Props>(SortBy);
